import { useFormContext } from 'react-hook-form'

export const useNewFormContext = () => {
  try {
    return useFormContext()
  } catch (error) {
    console.warn('Brak FormProvider', error)
  }
}
